module.exports = __webpack_public_path__ + "img/kinoko table.d161a4a5.png";